import { render } from "./BindWechatDialog.vue?vue&type=template&id=5f2bb14d"
import script from "./BindWechatDialog.vue?vue&type=script&lang=js"
export * from "./BindWechatDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__